import {OutlineButton} from '@/components/Button';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import DialogTemplate from '@/dialogs_common/DialogTemplate';
import SolidButton from '@/components/Button/SolidButton';
import FormTemplate from '@/dialogs_common/FormTemplate';
import { CheckCircleIcon } from '@heroicons/react/24/solid';

export default function Confirmation() {

  const navigate = useNavigate();

  return (
    <DialogTemplate>
      <FormTemplate
        title="My school or site"
        subtitle={(
          <div className="bg-green-100 p-4 rounded-lg text-left text-gray-700 border-green-500 border flex gap-2 items-start">
            <CheckCircleIcon className="size-5 shrink-0 text-cs-green-500 mt-0.5" />
            <div className="space-y-4">
            <div className="font-semibold">Thanks! We&apos;ve received your form!</div>
            <p>Thanks for taking the first step to set up your site! A CommunityShare team member will reach out soon to guide you through the next steps.</p>
            <p>In the meantime, you can explore ideas, resources, and opportunities on our platform.
            </p>
            </div>
          </div>
        )}
        footer={(
          <div className="flex justify-between w-full">
            <OutlineButton onClick={() => navigate(`/dashboard`, { replace: true })}>
              Cancel
            </OutlineButton>
            <SolidButton onClick={() => navigate(`/projects-events-populate`, { replace: true })}>
              Explore
            </SolidButton>
          </div>
        )}
      />
    </DialogTemplate>
  );
};
